import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { timeout } from 'sh-www/utils/timeout';
import Route from '@ember/routing/route';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';

const controllers = ['recommended', 'other', 'saved'].map(x => `postings.find-work.${x}`);

class PostingsRoute extends Route {
  @service session;

  get controllerName() {
    return this.session.currentUser?.isSeller
      ? 'postings.find-work'
      : null;
  }

  get templateName() {
    return this.session.currentUser?.isSeller
      ? 'postings'
      : null;
  }

  get isSeller() {
    return this.session.currentUser.isSeller;
  }

  afterModel() {
    if (!this.session.currentUser.isSeller) {
      return timeout(1);
    }
  }

  /** @inheritDoc */
  setupController(_, __, transition) {
    super.setupController(...arguments);

    if (!this.isSeller) {
      return;
    }

    const { targetName } = transition;
    const { queryParams } = transition.to;

    // we have to make a best guess here at the route query params since we are loading multiple child views at once
    controllers.forEach((controllerName) => {
      this.controllerFor(controllerName).initializeModel.perform(controllerName === targetName ? queryParams : { }, true);
    });
  }

  /** @inheritDoc */
  resetController(_, isExiting) {
    super.resetController(...arguments);

    if (!this.isSeller || !isExiting) {
      return;
    }

    controllers.forEach((controllerName) => {
      this.controllerFor(controllerName).invalidateModel.perform();
    });
  }

  /** @inheritDoc */
  @action
  willTransition(transition) {
    if (transition.targetName !== EMBER_ROUTE_NAMES.POSTINGS__FIND_WORK__OTHER) {
      const otherController = this.controllerFor('postings.find-work.other');

      // wipe the explore filters
      const queryParams = otherController.queryParams.reduce((accum, param) => {
        accum[param] = null;
        return accum;
      }, { });

      otherController.setProperties({
        ...queryParams,
      });
    }

    this.controllerFor('application').set('postingsCarousel', null);
    return true;
  }
}

export default PostingsRoute;
